import React, { Component } from "react"
import {
  Table,
  Icon,
  message,
  Spin,
  Input,
  Modal,
  Row,
  Dropdown,
  Menu,
  Tag,
} from "antd"
import "./Index.scss"
import CModalNoFooter from "app/components/normal/CModalNoFooter"
import config from "app/config"
import { observer, inject } from "mobx-react"
import editIcon from "app/styles/images/sp/edit.svg"
import titleIcon from "app/styles/images/sp/title.svg"
import closeIcon from "app/styles/images/sp/close.svg"
import recoveryIcon from "app/styles/images/sp/recovery.svg"
import deleteAbleIcon from "app/styles/images/sp/delete.svg"
import deleteDisableIcon from "app/styles/images/sp/delete-disable.svg"
import deleteWarningIcon from "app/styles/images/sp/delete-warning.svg"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import FlexableFileName from "app/components/normal/FlexableFileName"
import ShareModal from "app/components/normal/ShareModal"
import cx from "classnames"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import warningIcon from "app/styles/images/sp/data-warning.svg"
import DataOriginText from 'app/components/normal/DataOriginText'
import { PREPARE_RUN, RUNNING, SUCCESS, FAIL, CONTROL_FAIL_QUALITY } from 'app/utils/const'
import { withRouter } from 'react-router-dom'

@inject("entrance", "auth") @observer
class ReportCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shareModalShowed: false,
      detailModal: false,
      downLoadModal: false,
      showEditModal: false,
      dataIndex: 0,
      options: [],
      editGroupName: "",
      showDeleteModal: false,
      showDeleteGroupModal: false,
      showDeleteGroupReportModal:false,
      dataSingle: {},
      groupNameHistory: [],
      cancelShareModal: false,
    }
  }

  openDetail(record) {
    let { getDetailData } = this.props.store
    let { data = {}, history, match } = this.props

    const index = data.reportList.findIndex(report =>
      report.reportId === record.reportId
    )

    this.setState({
      dataIndex: index,
      reportDetail: null
    })

    let reportId = data.reportList[index].reportId
    getDetailData(reportId)
      .then(res => {
        record.isRead = true  // 点开过详情的设为已读
        this.setState({
          reportDetail: res
        })
      })
    history.push(`${match.url}/${data.groupName}/${reportId}`)
  }

  showShareModal = () => {
    this.setState({
      shareModalShowed: true
    })
  }

  showEditModal = () => {
    const { data, store: { getGroupListById } } = this.props

    this.setState({
      showEditModal: true,
      editGroupName: data.groupName
    })
    getGroupListById(data.groupId, "deleted")
  }

  closeModal = (modal, cb = () => { }) => {
    this.setState({
      [modal]: false
    }, cb)
  }

  copyText = (content) => {
    let targetId = "_hiddenCopyText_"
    let currentFocus = document.activeElement
    let target = document.getElementById(targetId)
    currentFocus.focus()

    // 如果不是，则使用节点的textContent
    if (!target) {
      //如果不存在，则创建一个
      target = document.createElement("textarea")
      target.style.position = "absolute"
      target.style.left = "-9999px"
      target.style.top = "0"
      target.id = targetId
      document.body.appendChild(target)
    }
    target.textContent = content
    // 聚焦目标节点，选中它的内容
    target.focus()
    target.setSelectionRange(0, target.value.length)

    // 进行复制操作
    try {
      document.execCommand("copy")
      message.success("复制链接成功")
    } catch (e) {
      message.error("复制链接失败")
    }

    // 不再聚焦
    if (currentFocus && typeof currentFocus.focus === "function") {
      currentFocus.focus()
    }

    // 清空临时数据
    target.textContent = ""
  }

  shareGroup = (username, clearUsername) => {
    let { shareGroup, shareList } = this.props.store
    let groupId = this.props.data.groupId

    shareGroup(groupId, username)
      .then(res => {
        clearUsername()
        shareList.unshift(res)
        message.success("分享成功")
      }, err => {
        message.error(err.message)
      })
  }

  downloadCsvStep = (templateId) => {
    const { downloadCsvStep } = this.props.store
    const { groupId } = this.props.data

    this.setState({
      downLoadModal: true,
    })
    downloadCsvStep(groupId)
      .then(res => {
        this.setState({
          downLoadModal: false,
        })
        if (document.getElementById("download-a-tag")) document.getElementById("download-a-tag").outerHTML = ""
        let a = document.createElement("iframe")
        a.setAttribute("src", res.url)
        a.setAttribute("id", "download-a-tag")
        a.setAttribute("style", "display:none;")
        document.body.appendChild(a)
      }, err => {
        message.error("下载失败，请您重试！")
        this.setState({
          downLoadModal: false,
        })
      })
  }

  export = () => {
    let { downloadCsvStep } = this.props.store
    const { groupId } = this.props.data

    this.setState({
      downLoadModal: true,
    })
    downloadCsvStep(groupId)
      .then(res => {
        this.setState({
          downLoadModal: false,
        })
        if (document.getElementById("download-a-tag")) document.getElementById("download-a-tag").outerHTML = ""
        let a = document.createElement("iframe")
        a.setAttribute("src", res.url)
        a.setAttribute("id", "download-a-tag")
        a.setAttribute("style", "display:none;")
        document.body.appendChild(a)
      }, err => {
        message.error("下载失败，请您重试！")
        this.setState({
          downLoadModal: false,
        })
      })
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    })
  }

  closeModal = (modal, cb = () => { }) => {
    this.setState({
      [modal]: false
    }, cb)
  }

  renderGroupButtons = () => {
    let { data = {} } = this.props

    if (data.mine) {
      return (
        <Row type="flex" justify="center" className="info-buttons">
          <a>
            <Row onClick={this.showEditModal} type="flex" justify="center" align="middle" gutter={3}>
              <img className="edit-btn" src={editIcon} alt="编辑" />
              <div>编辑</div>
            </Row>
          </a>
          <a onClick={this.downloadCsvStep}><Icon type="download" />组数据</a>
          <a onClick={this.showShareModal}><Icon type="upload" />共享</a>
        </Row>
      )
    } else {
      return (
        <Row type='flex' align='middle' justify='center' className='share-info'>
          <Icon type="share-alt" /> 数据来源于：<DataOriginText className='ellipsis'>{data.ownerName}</DataOriginText>
          <Dropdown
            overlay={(
              <Menu>
                <Menu.Item>
                  <a onClick={this.export}>
                    <Icon type="download" />导出
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a onClick={() => this.showModal('cancelShareModal')}>
                    <Icon type="close-circle-o" theme="outlined" />
                    取消共享
                  </a>
                </Menu.Item>
              </Menu>
            )}
            placement="bottomCenter"
          >
            <a className='more'>
              <Icon
                style={{ fontSize: 16, fontWeight: 'bold' }}
                type='ellipsis'
              />
            </a>
          </Dropdown>
        </Row>
      )
    }
  }

  toggleGroupNameHistory = (visible) => {
    if (visible) {
      //调接口
      const { store: { getHistory }, data: { groupId } } = this.props
      getHistory(groupId)
        .then(
          res => {
            this.setState({
              groupNameHistory: res
            })
          },
          err => {
            message.error("历史记录获取失败")
          }
        )
    } else {
      this.setState({
        groupNameHistory: []
      })
    }
  }

  editGroupOk = (editGroupName) => {
    //调接口
    const { store: { updateGroup }, data } = this.props

    if ((editGroupName || " ").trim() === "") {
      message.error("分组名称不能为空")
      return
    }
    updateGroup(data.groupId, editGroupName)
      .then(
        res => {
          if (data.groupName !== editGroupName) {
            data.groupName = editGroupName
            data.hasHistory = true
          }

          this.closeModal("showEditModal")
          message.success("编辑报告组成功")
        },
        err => {
          message.error(err)
        }
      )
  }

  renderGroupName = () => {
    const { data = {} } = this.props
    const { groupNameHistory } = this.state
    const { list: { queryMap: { keywords } } } = this.props.store
    const groupName = (
      <MaterialTip
        title={data.groupName}
      >
        <div className="cursor-p ellipsis">
          <Highlighter
            highlightClassName="lightlight"
            highlightStyle={{ fontWeight: "normal" }}
            searchWords={highlightable(data.groupName, keywords) ? [data.groupName] : []}
            textToHighlight={data.groupName}
          />
        </div>
      </MaterialTip>
    )

    if (data.hasHistory) {
      return (
        <WarningTip
          type="warningTip"
          text={groupName}
          justify="start"
          overlayClassName="ta-c"
          historyData={groupNameHistory}
          onVisibleChange={this.toggleGroupNameHistory}
        />
      )
    } else {
      return (
        <div>{groupName}</div>
      )
    }
  }

  checkOperatable = (record) => {
    return record.state === SUCCESS
  }

  showDeleteModal = (record) => {
    if (!this.checkOperatable(record)) {
      return
    }

    this.setState({
      showDeleteModal: true,
      dataSingle: record,
    })
  }

  showDeleteGroupModal = (record) => {
    this.setState({
      showDeleteGroupModal: true,
      dataSingle: record,
    })
  }
  showDeleteGroupReportModal= (record) => {
    this.setState({
      showDeleteGroupReportModal: true,
      dataSingle: record,
    })
  }

  deleteReport = (groupId) => {
    const { store: { deleteReport, recoveryTableData }, data } = this.props
    const { dataSingle } = this.state

    // 准备和运行中的数据无法删除
    if (dataSingle.state === PREPARE_RUN || dataSingle.state === RUNNING) {
      message.error("准备和运行中的数据无法删除")
      return
    }

    deleteReport(groupId, dataSingle.reportId)
      .then(res => {
        const deleteIndex = data.reportList.indexOf(dataSingle)
        recoveryTableData.unshift(dataSingle)
        data.reportList.splice(deleteIndex, 1)
        data.deletedDataCount++

        message.success("报告删除成功")
        this.setState({ showDeleteModal: false })

        this.refs.editModal
          && this.refs.editModal.wrappedInstance.refs.recoveryTable.wrappedInstance.showHistoryReport()
      }, err => {
        message.error(err.message)
      })
  }

  deleteGroup = () => {
    const { store: { deleteGroup, list: { tableData } }, data, groupIndex } = this.props
    deleteGroup(data.groupId)
      .then(
        res => {
          tableData.splice(groupIndex, 1)
          this.closeModal("showEditModal")
          this.closeModal("showDeleteGroupModal")
          message.success("删除报告组及报告成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  deleteGroupReport = () => {
    const { store: { deleteGroupReport, list: { tableData } }, data, groupIndex } = this.props
    deleteGroupReport(data.groupId)
      .then(
        res => {
          tableData.splice(groupIndex, 1)
          this.closeModal("showEditModal")
          this.closeModal("showDeleteGroupReportModal")
          message.success("删除报告成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false })
  }

  previewReport = (taskId) => window.open(`${config.backend}/azf/reports/preview/${taskId}`)

  render() {
    const { data, store, onOpenDetail, auth: { userInfo } } = this.props
    let {
      shareModalShowed,
      showDeleteModal,
      showDeleteGroupModal,
      showDeleteGroupReportModal,
      dataSingle,
      cancelShareModal,
    } = this.state

    const renderContent = (text, record, index) => {
      const obj = {
        children: text,
        props: {},
      }

      if (
        record.state === PREPARE_RUN
        || record.state === RUNNING
        || record.state === FAIL
        || record.qualityState === CONTROL_FAIL_QUALITY
      ) {
        obj.props.colSpan = 0
      }
      return obj
    }
    const deleteColumn = {
      title: "操作",
      dataIndex: "oprator",
      width: 50,
      className: "ta-c",
      render: (text, record, index) => {
        const operatable = this.checkOperatable(record)
        let imgClass = cx({
          "cursor-p": true,
          "disable": !operatable
        })
        let deleteIcon = operatable
          ? deleteAbleIcon
          : deleteDisableIcon

        return (
          <Row className="table-oprator ta-c" type="flex" justify="center" align="middle">
            <img
              className={imgClass}
              alt="删除"
              src={deleteIcon}
              onClick={() => this.showDeleteModal(record)} />
          </Row>
        )
      }
    }

    const deleteColumns = [
      {
        title: "文件名称",
        dataIndex: "filename",
        width: "25.1%",
        sorter: (a, b) => a.filename.localeCompare(b.filename),
        render: (text, record, index) => (
          <MaterialTip
            overlayClassName="ellipsis-tip"
            title={text}>
            <FlexableFileName
              onClick={() => this.openDetail(index)}
              filename={text}
            />
          </MaterialTip>
        )
      }, {
        width: "12.71%",
        title: "样本名称",
        dataIndex: "sampleName",
        sorter: (a, b) => a.sampleName && a.sampleName.localeCompare(b.sampleName),
        render: (text) => {
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis">{text}</div>
            </MaterialTip>
          )
        }
      }
    ]

    const columns = [
      {
        title: (
          <div className="unread-table-column dib">
            文件名称
          </div>
        ),
        dataIndex: "filename",
        width: "18.1%",
        sorter: (a, b) => a.filename.localeCompare(b.filename),
        render: (text, record, index) => {
          const operatable = this.checkOperatable(record)
          const filenameClass = cx({
            "filename blue-text2": true,
            "unread-table-column ": true,
            "unread-message": record.isRead === false,
            disable: !operatable,
            "cursor-p": operatable
          })
          const { list: { queryMap: { keywords } } } = this.props.store
          return (
            <div className={filenameClass} onClick={operatable && (() => onOpenDetail(data, record))}>
              {
                !record.isRead && (<div className="unread-icon"></div>)
              }
              <FlexableFileName filename={text} keywords={keywords} />
            </div>
          )
        }
      }, {
        width: "9.71%",
        title: "样本名称",
        dataIndex: "sampleName",
        sorter: (a, b) => a.sampleName && a.sampleName.localeCompare(b.sampleName),
        render: (text) => {
          const { list: { queryMap: { keywords } } } = this.props.store

          return (
            <MaterialTip title={text}>
              <div className="sample-name ellipsis">
                <Highlighter
                  highlightClassName="lightlight"
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={highlightable(text, keywords) ? [text] : []}
                  textToHighlight={text || ""}
                />
              </div>
            </MaterialTip>
          )
        }
      }
    ]

    if (data.reportList) {  // 新建组传文件且文件正在运行会没有reportList字段从而报错
      const statistical = [
        {
          title: "外部编号",
          className: "ta-r",
          dataIndex: "hospitalSampleName",
          render: renderContent
        },
        {
          title: "Total_Reads",
          className: "ta-r",
          dataIndex: "totalReads",
          render: (text, record, index) => {
            const stateData = [
              {
                text: "数据准备运行",
                className: "pre-run azf-state-element"
              },
              {
                text: "数据正在运行",
                className: "running azf-state-element"
              },
            ]

            if (record.qualityState === CONTROL_FAIL_QUALITY) {
              return {
                children: (
                  <Row type="flex" justify="center">
                    <div className="azf-state-element qc-failed">
                      <img className="warning-icon" alt="" src={warningIcon} />
                      {record.qualityContent}
                    </div>
                  </Row>
                ),
                props: {
                  colSpan: 6
                }
              }
            }

            switch (record.state) {
              case PREPARE_RUN:
                return {
                  children: (
                    <Row type="flex" justify="center" align="middle">
                      <div className={stateData[0].className}>
                        <Icon type="hourglass" />
                        {stateData[0].text}
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 7
                  }
                }
              case RUNNING:
                return {
                  children: (
                    <Row type="flex" justify="center" align="middle">
                      <div className={stateData[1].className}>
                        <Icon type="clock-circle-o" />
                        {stateData[1].text}
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 7
                  }
                }
              case FAIL:
                return {
                  children: (
                    <Row type="flex" justify="center">
                      <div className="azf-state-element run-failed">
                        <Icon type="close-circle" />
                        数据运行失败，
                        <div className="failed-button cursor-p" onClick={() => this.copyText(record.reportId)}>
                          点击复制错误信息
                        </div>
                        发送给管理员，将尽快为您解决问题。
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 7
                  }
                }
              default:
                return (<div>{text}</div>)
            }
          }
        },{
          title: "High_Quality",
          className: "ta-r",
          dataIndex: "highQuality",
          render: renderContent
        }, {
          title: "Mapping_Rate",
          className: "ta-r",
          dataIndex: "mappingRate",
          render: renderContent
        },{
          title: "Unique_Reads",
          className: "ta-r",
          dataIndex: "uniqueReads",
          render: renderContent
        }, {
          title: "GC",
          className: "ta-r",
          dataIndex: "gc",
          render: renderContent
        }, {
          title: "Library_Quality",
          className: "ta-r",
          dataIndex: "libraryQuality",
          render: renderContent
        }
      ]

      data.appName === 'AZF_PGM' ? statistical.splice(1, 0, {
        title: "Average_Length",
        className: "ta-r",
        dataIndex: "averageLength",
        render: renderContent,
        width: 135
      }) : statistical.splice(1, 0, {
        title: "Trimmomatic_Ratio",
        className: "ta-r",
        dataIndex: "trimmomaticRatio",
        render: renderContent,
        width: 135
      })
      const audit = {
        title: "审核状态",
        className: "ta-r",
        dataIndex: "reportState",
        render: (text, record, index) => {
          let stateMap = new Map([
            ['1', { color: '#f8b62d', text: '未审核' }], 
            ['2',
              userInfo.id === '64' ?
                { color: '#286cac', text: '已保存' } :
                { color: '#f8b62d', text: '未审核' }
            ],
            ['3', userInfo.id === '64' ?
              { color: '#69b823', text: '已审核' } :
              { color: '#69b823', text: '已审核' }
            ],
          ])
          const childrenEle = stateMap.get(text) ? (
            <Tag color={stateMap.get(text).color}>
              {stateMap.get(text).text}
            </Tag>
          ) : null
          const obj = {
            children: childrenEle,
            props: {}
          }
          if (record.state === PREPARE_RUN || record.state === RUNNING || record.state === FAIL) {
            obj.props.colSpan = 0
          }
          return obj
        }
      }

      columns.push(...statistical, deleteColumn)   // 需要删除功能时 加上deleteColumn
      columns.splice(10, 0, audit)
      deleteColumns.push(...statistical)
    }
    return (
      <Row type="flex" className="report-card">
        <div className="card-left">
          <div className="content">
            <div className="info">
              <Row type="flex" justify="start" align="middle" className="info-group">
                <label>数据类型：</label><div className="text-content">{data.appName}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>所在分组：</label>
                <div className="text-content">
                  {this.renderGroupName()}
                </div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>报告数量：</label><div className="text-content">{data.totalDataCount}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>已删除报告数量：</label><div className="deleted-count">{data.deletedDataCount}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>创建时间：</label><div className="text-content">{data.createTime}</div>
              </Row>
            </div>
            {
              this.renderGroupButtons()
            }
          </div>
        </div>
        <Table
          columns={columns}
          className="report-card-content"
          rowKey={record => record.reportId}
          dataSource={data.reportList.slice()} pagination={false} />

        {/* 分享modal */}

        {shareModalShowed &&
          <ShareModal
            visible
            store={store}
            action={this.shareGroup}
            onCancel={this.closeModal}
            data={data}
          />
        }

        {/* 下载modal */}

        <CModalNoFooter
          className="download-modal"
          width={230}
          visible={this.state.downLoadModal}
        >
          <div className="download-loading"><Spin size="large" /></div>
          <div className="download-tips">正在为您动态组装数据，请您稍等...</div>
        </CModalNoFooter>

        {/* 编辑modal */}
        {this.state.showEditModal &&
          <EditModal
            ref="editModal"
            store={store}
            data={data}
            editGroupOk={this.editGroupOk}
            onClose={() => this.closeModal("showEditModal")}
            checkOperatable={this.checkOperatable}
            showDeleteModal={this.showDeleteModal}
            showDeleteGroupModal={this.showDeleteGroupModal}
            showDeleteGroupReportModal={this.showDeleteGroupReportModal}
            deleteColumns={deleteColumns}
          />
        }

        {/* 删除单条modal */}
        {showDeleteModal &&
          <Modal
            className="pgx-modal reportcard-delete-modal"
            title={(
              <Row className="pgx-modal-title" type="flex" justify="center" align="middle" >
                <img src={titleIcon} alt="" />
                <div className="content">报告删除确认</div>
                <img src={titleIcon} alt="" />
              </Row>
            )}
            visible
            footer={(
              <Row
                type="flex"
                justify="center"
                align="middle"
                onClick={
                  () => this.deleteReport(data.groupId)
                }
              >
                <button className="pgx-modal-delete-btn" type="primary">删除</button>
              </Row>
            )}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={this.closeDeleteModal}
            />
            <Row type="flex" justify="center" align="middle">
              {dataSingle.filename}
            </Row>
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确定要删除本条报告吗？</div>
            </Row>
          </Modal>
        }
        {/* 删除组modal */}
        {showDeleteGroupModal &&
          <Modal
            className="pgx-modal reportcard-delete-modal"
            title={(
              <Row className="pgx-modal-title" type="flex" justify="center" align="middle" >
                <img src={titleIcon} alt="" />
                <div className="content">报告组删除确认</div>
                <img src={titleIcon} alt="" />
              </Row>
            )}
            visible
            footer={(
              <Row
                type="flex"
                justify="center"
                align="middle"
                onClick={
                  () => this.deleteGroup()
                }
              >
                <button className="pgx-modal-delete-btn" type="primary">删除</button>
              </Row>
            )}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={() => this.closeModal("showDeleteGroupModal")}
            />
            {/* <Row type="flex" justify="center" align="middle">
              {dataSingle.filename}
            </Row> */}
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确定要删除本组报告吗？</div>
            </Row>
          </Modal>
        }

          {/* 删除报告modal */}
          {showDeleteGroupReportModal &&
          <Modal
            className="pgx-modal reportcard-delete-modal"
            title={(
              <Row className="pgx-modal-title" type="flex" justify="center" align="middle" >
                <img src={titleIcon} alt="" />
                <div className="content">报告删除确认</div>
                <img src={titleIcon} alt="" />
              </Row>
            )}
            visible
            footer={(
              <Row
                type="flex"
                justify="center"
                align="middle"
                onClick={
                  () => this.deleteGroupReport()
                }
              >
                <button className="pgx-modal-delete-btn" type="primary">删除</button>
              </Row>
            )}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={() => this.closeModal("showDeleteGroupReportModal")}
            />
            {/* <Row type="flex" justify="center" align="middle">
              {dataSingle.filename}
            </Row> */}
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确定要删除本组报告吗？</div>
            </Row>
          </Modal>
        }

        {/* 取消分享modal */}

        {cancelShareModal &&
          <MaterialModal
            className="pgs-datamanage-delete-modal"
            title="取消分享确认"
            visible={true}
            action={() => {
              store.cancelShare(data.groupId, data.ownerId, 'fromId')
                .then(
                  res => { this.closeModal("cancelShareModal") },
                )
            }}
            buttonText="确认"
            buttonType="danger"
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={() => this.closeModal("cancelShareModal")}
            />
            <Row type="flex" justify="center" align="middle">
              {data.groupName}
            </Row>
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确认取消 {data.ownerName} 共享给您的数据吗？</div>
            </Row>
          </MaterialModal>
        }
      </Row>
    )
  }
}

@observer
class EditModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dataSingle: {},
      groupName: props.data.groupName
    }

    this.deleteColumns = [...props.deleteColumns, {
      title: "操作",
      dataIndex: "oprator",
      width: 50,
      className: "ta-c",
      render: (text, record, index) => {
        const operatable = props.checkOperatable(record)
        let imgClass = cx({
          "cursor-p": true,
          "disable": !operatable
        })
        let deleteIcon = operatable
          ? deleteAbleIcon
          : deleteDisableIcon

        return (
          <Row className="table-oprator ta-c" type="flex" justify="center" align="middle">
            <img
              className={imgClass}
              alt="删除"
              src={deleteIcon}
              onClick={() => props.showDeleteModal(record)} />
          </Row>
        )
      }
    }]

    this.recoveryColumns = [...props.deleteColumns,
    {
      title: "操作",
      dataIndex: "oprator",
      width: 50,
      className: "ta-c",
      render: (text, record, index) => {
        return (
          <Row className="table-oprator ta-c" type="flex" justify="center" align="middle">
            <img alt="恢复" src={recoveryIcon} onClick={() => this.recoveryReport(record, index)} />
          </Row>
        )
      }
    }
    ]
  }

  recoveryReport = (record, recoveryIndex) => {
    const { store: { recoveryReport, recoveryTableData }, data } = this.props

    //调接口
    recoveryReport(data.groupId, record.reportId)
      .then(
        res => {
          recoveryTableData.splice(recoveryIndex, 1)
          data.reportList.unshift(record)
          data.deletedDataCount--

          message.success("报告恢复成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  onGroupNameChange = (e) => {
    this.setState({
      groupName: e.target.value
    })
  }

  render() {
    const { data, onClose, editGroupOk, store, showDeleteGroupModal,showDeleteGroupReportModal } = this.props
    const { groupName } = this.state

    return (
      <MaterialModal
        className="azf-reportcard-edit-modal"
        title="编辑报告组"
        visible
        width={1160}
        footer={(
          <Row type="flex" justify="center" align="middle">
            <button
              className="delete-group-btn"
              onClick={showDeleteGroupModal}
            >
              删除报告组及报告
            </button>
            <button
              className="delete-group-btn"
              onClick={showDeleteGroupReportModal}
            >
              删除报告
            </button>
          </Row>
          
        )}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <Row type='flex' justify='start' align='middle' className='subtitle'>
          <i></i>
          <MaterialFormItem
            labelWidth={47}
            labelText="分组名称"
            className="group-name">
            <Row type="flex" justify="start" align='middle'>
              <Input
                onChange={this.onGroupNameChange}
                name="groupName" type="text"
                className="name-input"
                defaultValue={data.groupName}
                placeholder="请输入分组名称"
              />
            </Row>
          </MaterialFormItem>
          <button className="primary-btn confirm" onClick={() => editGroupOk(groupName)}>确认修改分组</button>
        </Row>
        <Table columns={this.deleteColumns}
          rowKey={record => record.reportId + "delete"}
          scroll={{ y: 235 }}
          className="delete-table"
          dataSource={data.reportList.slice()} pagination={false} />
        <RecoveryTable
          store={store}
          ref="recoveryTable"
          recoveryColumns={this.recoveryColumns}
        />

        {/* 删除确认modal */}
      </MaterialModal>
    )
  }
}

@inject("entrance") @observer
class RecoveryTable extends Component {
  state = {
    isFirstRender: true,
    showHistoryReport: false
  }

  toggleHistoryReport = () => {
    this.setState({
      showHistoryReport: !this.state.showHistoryReport,
      isFirstRender: false
    })
  }

  showHistoryReport = () => {
    this.setState({
      showHistoryReport: true,
      isFirstRender: false
    })
  }

  /**
   * 需求描述：
   *    第一次进来时、数据渲染到后且 showHistoryReport false 时展示 [], 其他条件均展示真实数据
   */
  render() {
    const { showHistoryReport, isFirstRender } = this.state
    const { recoveryColumns, store: { recoveryTableData } } = this.props

    const recoveryTableClass = cx({
      "recovery-table": true,
      "close": !showHistoryReport,
    })
    const extendBtnClass = cx({
      "close-btn": showHistoryReport,
      "extend-btn": !showHistoryReport
    })

    return (
      <div>
        <Row type='flex' justify='start' align='middle' className='subtitle history'>
          <i></i>
          <b>已删除报告（{recoveryTableData.length}条）</b>
          <div className="line"></div>
          <button onClick={this.toggleHistoryReport} className={extendBtnClass}>
            {showHistoryReport ? "收起" : "展开"}
          </button>
        </Row>
        <Table
          columns={recoveryColumns}
          rowKey={record => record.reportId + "recovery"}
          scroll={{ y: 141 }}
          className={recoveryTableClass}
          dataSource={isFirstRender ? [] : recoveryTableData.slice()} pagination={false} />
      </div>
    )
  }
}

export default withRouter(ReportCard)



// WEBPACK FOOTER //
// ./src/app/components/normal/azf/ReportCard/index.js